// export const BASE_URL = 'http://localhost/diarise_mfg_apis/public/'
export const BASE_URL = 'https://diarise.dkinfoway.com/apis/public/'
// export const BASE_URL = 'https://diarisetest.dkinfoway.com/apis/public/'
// export const BASE_URL = 'https://bluemoonapi.dkinfoway.com/'
// export const BASE_URL = 'http://127.0.0.1:8000/api'

export const BASE_NAME = 'DIARISE LLP'
